import { ExtendedListChildComponentProps } from "@/components/core/InfiniteScrollList/VirtualizedList";
import { Skeleton } from "@/components/ui/skeleton";

type TeamMemberCardSkeletonProps = ExtendedListChildComponentProps;

export function TeamMemberCardSkeleton({
  style,
  ref,
}: TeamMemberCardSkeletonProps) {
  return (
    <div style={style}>
      <div className="flex items-center gap-4 p-4 rounded-lg border bg-card text-card-foreground shadow-sm" ref={ref}>
        <div className="flex-1 min-w-0">
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-5 w-16 rounded-full" />
      </div>
    </div>
  );
}

